import { render, staticRenderFns } from "./SanctionsTable.vue?vue&type=template&id=2e8cf2b9&scoped=true"
import script from "./SanctionsTable.vue?vue&type=script&lang=js"
export * from "./SanctionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cf2b9",
  null
  
)

export default component.exports